import React, { useState, useEffect } from 'react';
import './App.css';
import { supabase } from './supabaseClient';
import Landing from './components/Landing';
import Auth from './components/Auth';
import TransformationAssessment from './components/TransformationAssessment';
import JourneyRecommendations from './components/JourneyRecommendations';
import BookingCheckout from './components/BookingCheckout';
import PartnerDashboard from './components/PartnerDashboard';

const PROTECTED_PAGES = ['assessment', 'recommendations', 'checkout', 'partner'];

function App() {
  const [currentPage, setCurrentPage] = useState('landing');
  const [session, setSession] = useState(null);
  const [authChecked, setAuthChecked] = useState(false);
  const [authMode, setAuthMode] = useState('signin');

  useEffect(() => {
    const hash = window.location.hash.slice(1) || 'landing';
    const page = hash.split('?')[0] || 'landing';
    setCurrentPage(page);

    const handleHashChange = () => {
      const newHash = window.location.hash.slice(1) || 'landing';
      const newPage = newHash.split('?')[0] || 'landing';
      setCurrentPage(newPage);
    };

    window.addEventListener('hashchange', handleHashChange);
    return () => window.removeEventListener('hashchange', handleHashChange);
  }, []);

  useEffect(() => {
    supabase.auth.getSession().then(({ data }) => {
      setSession(data.session);
      setAuthChecked(true);
    });

    // PASSWORD_RECOVERY fires when a user lands here via the reset-password
    // email link - Supabase's client parses the recovery token from the URL
    // itself (independent of our own hash-based router above), so we force
    // navigation to the auth page's reset form regardless of what the router
    // computed the current page to be.
    const { data: listener } = supabase.auth.onAuthStateChange((event, newSession) => {
      setSession(newSession);
      if (event === 'PASSWORD_RECOVERY') {
        setAuthMode('reset');
        setCurrentPage('auth');
      }
    });

    return () => listener.subscription.unsubscribe();
  }, []);

  const navigate = (page, params = '') => {
    window.location.hash = params ? `${page}${params}` : page;
  };

  const handleSignOut = async () => {
    await supabase.auth.signOut();
    navigate('landing');
  };

  return (
    <div className="App">
      {currentPage === 'landing' && <Landing onNavigate={navigate} session={session} onSignOut={handleSignOut} />}
      {currentPage === 'auth' && (
        <Auth
          initialMode={authMode}
          onNavigate={navigate}
          onAuthComplete={() => navigate('landing')}
        />
      )}
      {PROTECTED_PAGES.includes(currentPage) && !authChecked && (
        <div className="App-loading">Loading…</div>
      )}
      {PROTECTED_PAGES.includes(currentPage) && authChecked && !session && (
        <Auth initialMode="signin" onNavigate={navigate} onAuthComplete={() => {}} />
      )}
      {currentPage === 'assessment' && authChecked && session && <TransformationAssessment onNavigate={navigate} />}
      {currentPage === 'recommendations' && authChecked && session && <JourneyRecommendations onNavigate={navigate} />}
      {currentPage === 'checkout' && authChecked && session && <BookingCheckout />}
      {currentPage === 'partner' && authChecked && session && <PartnerDashboard />}
    </div>
  );
}

export default App;
